/**
 * 购物车接口封装
 */
import request from '@/axios/request.js'

// 添加到购物车
export function cartAdd (data) {
  // origin
  // {
  //     "bargainId": 0, 产品砍价ID
  //     "cartNum": 0, 购物车数量
  //     "combinationId": 0, 产品拼团ID
  //     "new": 0, 是否新购买
  //     "productId": 0, 产品ID
  //     "secKillId": 0, 产品秒杀ID
  //     "uniqueId": "" 唯一的ID，商品规格？
  // }
  // latest @Karen
  // {
  //   "cartNum": 1,  购物车数量(永远是1)
  //   "productId": 9,  产品ID
  //   "uniqueId": "800a14d85543484bade1356d06e3d6f2",
//      "sampleCartInfo": {
//         "detectionMethodList": ["1", "3", "4"],
//         "sampleForm":"样品状态",
//         "sampleAlias":"样品别名",
//         "sampleOptions":["1","2"]
//       }
  // }
  return request({
    url: '/mall/cart/add',
    method: 'post',
    data
  })
}

// 获取数量
export function cartCount () {
    return request({
        url: '/mall/cart/count',
        method: 'get'
    })
}

// 删除购物车产品
export function cartDel (data) {
    // {
    //     "ids": [] 购物车ID，多个用,分隔开
    // }
    return request({
        url: '/mall/cart/del',
        method: 'post',
        data
    })
}

// 获取购物车列表
export function cartList () {
    return request({
        url: '/mall/cart/list',
        method: 'get'
    })
}

// 更新购物车
export function cartUpdate (data) {
    // {
    //     "id": 0, 购物车ID
    //     "number": 0  购物车数量
    // }
    return request({
        url: '/mall/cart/num',
        method: 'post',
        data
    })
}

// 加载委托单暂存信息
export function cartLoad() {
  return request({
    url: '/mall/cart/load',
    method: 'get'
  })
}

// 委托单信息暂存
export function cartSave(data) {
  // {
  //   "detection":{
  //     "arbitration":false,
  //     "addressList":[
  //       {
  //         "id":39,
  //         "realName":"realName",
  //         "phone":"110",
  //         "province":"北京",
  //         "city":"北京",
  //         "district":"大兴区",
  //         "detail":"西红门派出所",
  //         "postCode":"10000",
  //         "fax":"110",
  //         "email":"xlj@bgrimm.com",
  //         "delivery":["1"],
  //         "clientId":"4",
  //         "clientName":"北矿检测1"
  //       }
  //     ],
  //     "comment":"我们这单经过你们老总同意，不用付钱，你们倒贴10万元，你们抓紧时间测，然后打款就行",
  //     "detectionDate":"1659591535000",
  //     "expressNum":"123,1122,333"
  //   }
  // }
  return request({
    url: '/mall/cart/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/cart.js